import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { IWebSite } from "../../models/WebSite";
import { useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";

import { JVDropdown } from "../../shared/JVDropdown";
import { Accordion, AccordionTab } from "primereact/accordion";
import { JVCheckbox } from "../../shared/JVCheckbox";
import { JVDate } from "../../shared/JVDate";
import { JVTime } from "../../shared/JVTime";
import { format } from "date-fns";
import { ITestingEmail } from "../../models/TestingEmailSetting";
import { EmptyTestingEmail } from "./EmptyTestingEmail";

const schema = yup.object({

    sales_Email:yup.string().email("Invalid email").required(" sales Email is required"),
    recruiter_Email:yup.string().email("Invalid email").required(" Recruiter Email is required").nullable(),
    sales_Head_Email: yup.string().email("Inavlid Email").required("Sales Head Email is required").nullable(),
    recruiter_Head_Email: yup.string().email("Inavlid Email").required("Recruiter head Email is required").nullable(),
    branch_Head_Email: yup.string().email("Invalid Email").required("Branch Head Email is required").nullable(),
    consultant_Email:yup.string().email("Invalid Email").required("Consultant Email is required").nullable(),
});
interface Iprops {
    singleData: ITestingEmail,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}


export const Form = (props: Iprops) => {
    const { control, handleSubmit, formState: { errors }, reset } = useForm<ITestingEmail>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });
    useEffect(() => {
        reset(props.singleData);
    }, [props.singleData])

  
    const saveToDB = async (body: ITestingEmail) => {
        const method = props.singleData.setting_Id ? "PUT" : "POST";
        const message = props.singleData.setting_Id ? "Updated Successfully" : "Added Successfully";
        const response = await Fetch("Testing_Email_Settings", method, body, null, props.toast);
        if (response) {
            props.hideDialog();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.setReload(!props.reload);
        }
    }

    const onHide = () => {
        props.hideDialog();
        reset(EmptyTestingEmail);
    }

    const getSetting = async () => {
        const response = await Fetch("Testing_Email_Settings/byId", "GET", null, `Setting_Id=${props.singleData.setting_Id}`, props.toast);
        if (response) {
            const data: any = await response.json();
            reset(data);
        }
    }
    useEffect(() => {
        if (props.singleData.setting_Id) {
            getSetting();
    }
      
    }, [props.singleData]);
    
  
    function onSubmit(data: ITestingEmail) {
        saveToDB(data);
    }
    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add Template" modal className="p-fluid" onHide={onHide} maximizable>
            <form onSubmit={handleSubmit(onSubmit)} >
                <Accordion multiple activeIndex={[0]}>
                    <AccordionTab header="Email Sending Setting">
                        <div className="p-fluid formgrid grid">
                            <JVInput required column={4} label="Sales Email " control={control} name="sales_Email" error={errors.sales_Email?.message}  />
                            <JVInput required column={4} label="Recruiter Email " control={control} name="recruiter_Email" error={errors.recruiter_Email?.message}  />
                            <JVInput required column={4} label="Sales Head Email " control={control} name="sales_Head_Email" error={errors.sales_Head_Email?.message}   />
                            <JVInput required column={4} label="Recruiter Head Email " control={control} name="recruiter_Head_Email"  error={errors.recruiter_Head_Email?.message} />
                            <JVInput required column={4} label="Branch Head Email " control={control} name="branch_Head_Email" error={errors.branch_Head_Email?.message}   />
                            <JVInput required column={4} label="Consultant Email " control={control} name="consultant_Email" error={errors.consultant_Email?.message}   />

                        </div>
                    </AccordionTab>
                    
                </Accordion>
                <div style={{ margin: '10px 0', width: '100%' }}></div>
                <div className="col-12 md:col-12">
                    <Button className="field col-12 md:col-6 h-2rem " label="SAVE" type="submit"></Button>
                    <Button className="field col-12 md:col-6 p-button-outlined h-2rem" label="CLOSE" onClick={onHide} type="button"></Button>
                </div>
            </form>
        </Dialog>
    );
}
